import { useEffect } from 'react';
import { useIsFocused } from '@react-navigation/native';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogViewNewFavorited = (isActive: boolean) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const isFocused = useIsFocused();

  useEffect(() => {
    if (!isFocused || !isActive) return;
    logAnalyticsEvent({
      name: 'VIEW_NEW_FAVORITED',
      channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
    });
  }, [isFocused, isActive, logAnalyticsEvent]);
};
